import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import { takeUntil } from "rxjs/operator/takeUntil";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { GrnService } from "../../../services/grn.service";
import { Combo2Service } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";

@Component({
  selector: "addEditGrn",
  templateUrl: "./addEditGrn.html",
  //    changeDetection:ChangeDetectionStrategy.OnPush
})
export class AddEditGrn {
  state: boolean = false;
  headerShow: boolean = true;
  bodyShow: boolean = false;
  footerShow: boolean = false;
  samplePending: boolean = false;
  returnDesigns: boolean = false;
  Is_Mismatch: boolean = false;
  selected: any = [];
  selectedReturn: any = [];
  designOrderedList = [];
  type: any;
  row: any;
  data: any;
  auto_number: number;
  designdata: any = { indent_no: 0, rcvd_type_name: "" };
  grnData: any = {
    inv_ref_no: "",
    order_no: 0,
    totalqty: 0,
    grn_date: "",
    grn_no: "",
    po_no: "",
    lr_y_date: "",
    inv_y_date: "",
    party_code: "",
    party_name: "",
    rcvd_type: "",
    rcvd_type_name: "",
    lr_no: "",
    lr_date: "",
    lr_amnt: "",
    inv_no: "",
    grn_type: "",
    inv_date: "",
    inv_amnt: "",
    no_of_bales: 0,
    grn_id: "",
    lr_date_formatted: "",
    inv_id: "",
    party_id: "",
    totalamt: 0,
    grand_total: 0,
    round_off: 0,
    discount: 0,
    extras: 0,
    others: 0,
    tax_amount: 0,
    tax_per: 0,
    inv_date_formatted: "",
    pvt_mark: 0,
    indent_no: 0,
    invoice_type: "TRANSPORT",
    narration: "",
  };

  partydata: any = {
    cour_id: 0,
    cour_no: "",
    cour_date: "",
    cour_name: ""
  };
  qualityList: any;
  partyDetails = [];
  grnCompareList = [];
  invoiceCompareList = [];
  mismatchList = [];
  colorList: any;
  colorListback: any;
  styleList1: any;
  codeList: any;
  poList: any;
  invList: any;
  widthList: any[];
  grndata: any = {};
  mode: string;
  saveEvent: any;
  partyCodeList: any;
  partyList: any;
  OdList: any;
  poNoList: any;
  design_no: any;
  lrList: any;
  LRList: any;
  design_auto_no: any;
  designList = [];
  designColorList: any;
  samplePendingList = [];
  returnDesignList = [];
  isLoading: boolean = false;
  sample_check: boolean = false;
  finyearList = [];
  tempcolorList: any;
  private loadedPdCodeMap: {[ind: number]: string} = {};
  loadingRowInd: number = -1;
  varietyList = [];
  varietyList1 = [];
  designnoList = [];
  typeList: any;
  tempData = [];
  invoiceList = [];
  sampleList = [{ name: "YES" }, { name: "NO" }];
  designType = [{ name: "CORE" }, { name: "NEW" }];
  typeList1 = [
    // { name: "OPENING" },
    { name: "BULK" },
    // { name: "MATCHING" },
    { name: "SAMPLE" },
    { name: "SWATCH" },
    // { name: "WO RETURN" },
    { name: "SAMPLE & SWATCH" },
    { name: "BULK & SAMPLE" },
  ];
  shipList = [{ name: "LR" }, { name: "COU" }, { name: "HD" }];

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    let grnData = Object.assign({}, val["data"]);
    this.saveEvent = val["data"].tabevent;
    this.grnData = grnData;
    if (this.mode == "Edit" || this.mode == "View") {
      this.loadeditgrnlist();
      this.getDesign(this.grnData.po_no);
      this.grnData.inv_y_date = this.grnData.inv_date;
      this.grnData.lr_y_date = this.grnData.lr_date;
      this.onEnterpono(this.grnData.po_no);
      // Load LR list filtered by party — avoids full 365-day unfiltered query
      if (this.grnData.party_id) {
        this.lrlist({ party_id: this.grnData.party_id });
      }
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("lrAuto") lrAuto;
  @ViewChild("finAuto") finAuto;
  @ViewChild("poAuto") poAuto;
  @ViewChild("invAuto") invAuto;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("type1Auto") type1Auto;
  @ViewChild("shipAuto") shipAuto;
  @ViewChild("designAuto") designAuto;
  @ViewChild("colorAuto") colorAuto;
  @ViewChild("grntypeAuto") grntypeAuto;

  widthCtrl: FormControl = new FormControl();
  designCtrl: FormControl = new FormControl();
  pdesignCtrl: FormControl = new FormControl();
  samTypeCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  grnControl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  poCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  lrCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  shipCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private combo: Combo2Service,
    private grn: GrnService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {
    this.row = {
      design_no: "",
      type1: "",
      type: "",
      quality: "",
      recvd_width: "",
      qty: 0,
      rate: 0,
      amount: 0,
      pd_code: "",
      p_shade: "",
      design_type: "",
      shade: "",
      color: "",
      style: "",
      actWidth: "",
      lc_rate: 0,
    };
    this.data = {
      grnList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.grnList.push(row);

    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
  }
  ngOnInit() {
    console.log(this.grnData.inv_ref_no);
    this.getVarietyList();

    this.finyearCombo();
    this.qualitylist();
    this.colorlist();
    // this.styleList();
    this.widthlist();
    this.codelist();
    this.typelist();
    this.polist();
    this.tableScroll();
    // this.validateInvoice();
    if (this.mode == "Add") {
      this.grnData.grn_type = "BULK";
      this.grnData.grn_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.grnData.discount = 0;
      this.grnData.tax_amount = 0;
      this.grnData.tax_per = 0;
      this.grnData.others = 0;
      this.grnData.extras = 0;
      this.grnData.grand_total = 0;
      this.grnData.round_off = 0;
      this.grnData.invoice_type = "TRANSPORT";

      //     this.generateOdNo();
      //     this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#inv_ref_no").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design_no = this.data.grnList[ind]["design_no"],
      quality = this.data.grnList[ind]["quality"],
      type = this.data.grnList[ind]["type"],
      type1 = this.data.grnList[ind]["type1"],
      design_type = this.data.grnList[ind]["design_type"],
      pd_code = this.data.grnList[ind]["pd_code"],
      //  width = this.data.designList[ind]['width'],
      mtrs = this.data.grnList[ind]["mtrs"],
      recvd_width = this.data.grnList[ind]["recvd_width"],
      rate = this.data.grnList[ind]["rate"],
      amt = this.data.grnList[ind]["amt"];

    let nxtRow = $("#row-" + ind).next("tr");

    if ((design_no != "" && pd_code != "") || design_type != "") {
      if (fld == "pdcode" && nxtRow.length == 0) {
        for (let i = 0; i < this.data.grnList.length; i++) {
          if (ind + 1 == this.data.grnList.length) {
            this.row.lc_per = this.grnData["lc_per"];

            let rowdetail = Object.assign({}, this.row);

            this.data.grnList.push(rowdetail);

            nxtInd = this.data.grnList.length - 1;
            setTimeout(() => {
              $("#pdcode" + "-" + nxtInd).focus();
            }, 500);
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  CheckOrdNo(ind){
    if(!this.data.grnList[ind].book_no){
      swal("ERROR","Please Enter PO.Order No!!!","error")
      this.data.grnList.splice(ind + 1)
    }
  }
  tableScroll() {
    const h = window.innerHeight - 495;
    $(".invscreen").css("height", h + "px");
    $(".grnbody").width(window.innerWidth - 30);
  }
  onDeleteRow($event, fld, ind) {
    if (this.data.grnList.length > 1) {
      this.data.grnList.splice(ind, 1);

      if ($("#" + fld + "-" + (ind - 1)).length > 0) {
        $("#" + fld + "-" + (ind - 1)).focus();
      } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
        $("#" + fld + "-" + (ind + 1)).focus();
      }
    }
    this.calcTotal();
  }
  onDeleteDesignRow(i){
    this.partyDetails.splice(i,1)
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.grn.getAuto({}).then((res: any) => {
      this.grnData.grn_no = res;
      this.onSaveGrn();
    });
  }
  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {
      let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
      }, []);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }
  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }
  colorlist() {
    this.sample_check = false;
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
      this.colorListback = [...this.colorList];
    });
  }
  styleList() {
    this.poservice.styleList({}).then((res: any) => {
      // this.styleList1 = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.codeList = res.data;
      /*  if (this.mode == "Edit") {
                      this.partyCtrl.setValue(this.designdata['party_name']);
                  }*/
    });
  }
  polist() {
    this.grn.getPoList({}).then((res: any) => {
      this.poList = res.data;
    });
  }
  lrlist(query: any = {}) {
    this.grn.getLrList(query).then((res: any) => {
      this.lrList = res.data;
      if (res.auto_design) {
        this.auto_number = res.auto_design;
      }
    });
  }
  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.codeList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_name: id });
      this.designdata.party_id = fitem["party_id"];
      return fitem["party_name"];
    }
    return "";
  }
  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      if (!fitem) {
      }

      return fitem["finyear"];
    }
    return "";
  }

  onSaveGrn(): void {
    if (
      this.grnData.po_no == "" ||
      this.grnData.grn_type == "" ||
      this.grnData.inv_no == ""
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      if (this.grnData.inv_amnt !== parseInt(this.grnData.grandTotal)) {
        swal({
          title: "Invoice Amount and Grand Total are not equal",
          //  timer: 1000,
          type: "warning",
          showCancelButton: false,
          showConfirmButton: false,
        });
      }

      this.data.grnList.forEach((el) => {
        let data = this.grnCompareList.find(
          (temp) => temp.pd_code == el.pd_code && temp.shade == el.color
        );
        if (!data) {
          data = {
            pd_code: el.pd_code,
            color: el.shade,
            shade: el.color,
            width: el.recvd_width,
            actWidth: el.actWidth,
            quality: el.quality,
            type: el.type,
            rate: el.rate,
            lc_per: el.lc_per,
            amount: el.amount,
            style: el.style,
            design_no: el.design_no,
            qty: 0,
          };
          this.grnCompareList.push(data);
        }
        data.qty += el.qty;
      });
      let tempArry = [];
      this.invoiceList.forEach((element) => {
        let data = this.grnCompareList.filter(function (temp) {
          if (
            temp.pd_code == element.design_no &&
            temp.shade == element.shade &&
            temp.qty !== element.qty
          ) {
            let diff = element.qty - temp.qty;
            if (diff < 0) {
              temp["type"] = "EXCESS";
            } else {
              temp["type"] = "SHORTAGE";
            }
            temp["difference"] = diff;
            tempArry.push(temp);
          }
        });
      });
      this.mismatchList = tempArry;
      this.data.mismatchList = this.mismatchList;
      let params: any = Object.assign({}, this.grnData);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data);
      params["miss_goods"] = JSON.stringify(this.partyDetails);
      params["pvt_mark"] = this.grnData.pvt_mark || "";
      params["lr_id"] = this.grnData.lr_id || "";
      params["lr_amnt"] = this.grnData.lr_amnt || "";
      params["lr_date"] = this.grnData.lr_date || "";
      params["mode"] = this.mode;
      params["grn_date"] = this.datePipe.transform(
        params["grn_date"],
        "yyyy-MM-dd"
      );
      params["narration"] = this.grnData.narration;
      let that = this;

      swal({
        title: "Are you sure to save this Grn?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.grn
          .saveGrn(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
                // that.saveEvent.emit();
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            if (res.description.includes("Undefined variable")) {
              if (res.description.split(": ")[1] == "lr_date") {
                res.message = "Lr Date is Undefined";
              } else if (res.description.split(": ")[1] == "diff_days") {
                res.message = "Difference days is Undefined";
              } else {
                res.message = res.description.split(": ")[1] + " is Undefined";
              }
            }
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  loadeditgrnlist() {
    let params = {
      grn_id: this.grnData.grn_id,
      grn_qty : true
    };
    this.grn.getEditGrnList(params).then((res: any) => {
      this.data.grnList = res.data;
      this.design_no = res.design_no - 1;
      this.calcTotal();
      // this.change.detectChanges();
      // this.calcQty();
    });
  }
  // totalamount() {
  //     let params = {
  //         grn_id: this.grnData.grn_id,
  //     };
  //     this.grn
  //         .totalamount(params)
  //         .then((res: any) => {

  //             this.data.grnList = res.data;
  //             this.design_no = res.design_no - 1;
  //             this.calcTotal();
  //             // this.calcQty();

  //         });
  // }

  onClickCode(party_code) {
    let partyCodeList = _.filter(this.codeList, { code: party_code });
    this.partyCodeList = partyCodeList;
    let poNoList = _.filter(this.poList, { party_code: party_code });
    this.poNoList = poNoList;
  }
  onClickParty(party_name) {
    let LRList = _.filter(this.lrList, { party_name: party_name });
    this.LRList = LRList;
  }
  onClickLr(lr_no, skipDesignList = false) {
    if (lr_no !== "") {
      if (this.grnData.invoice_type == "TRANSPORT") {
        let invList = _.filter(this.lrList, { lr_no: lr_no });
        this.invList = invList;

        this.grnData["lr_date"] = invList[0]["lr_date"];
        this.grnData.lr_y_date = invList[0]["lr_date"];
        this.grnData["lr_amnt"] = invList[0]["lr_amount"];
        this.grnData["lr_id"] = invList[0]["plr_id"];
        this.grnData.pvt_mark = invList[0]["pvt_mark"];
      } else if (this.grnData.invoice_type == "COURIER") {
        let invList = _.filter(this.lrList, { courier_no: lr_no });
        this.invList = invList;

        if (invList.length > 1) {
          this.grnData["lr_date"] = this.tempData["courier_date"];
          this.grnData["lr_y_date"] = this.tempData["courier_date"];
        } else {
          this.grnData["lr_date"] = invList[0]["courier_date"];
          this.grnData["lr_y_date"] = invList[0]["courier_date"];
        }
      }
      if (!skipDesignList) {
        let params = {
          lr_no: lr_no,
          po_id: this.grnData.po_id,
        };
        this.grn.getDesignList(params).then((res: any) => {
          this.invoiceList = res.data;
        });
      }

      this.calcDiff();
      this.calcLCrate();
    } else {
      this.grnData.lr_y_date = "";
      this.grnData["lr_amnt"] = "";
    }
  }
  colorVal(data, ind) {
    if (data && data != "" && this.data.grnList[ind].design_type == "NEW") {
      if (this.colorList.find((name) => name.name == data)) {
        return true;
      } else {
        swal("Please Check The Color Spelling!");
        this.data.grnList[ind].shade = "";
        return false;
      }
    }
  }

  calcLCrate() {
    if (!this.grnData.totalinvamt) return this.data.grnList;
    for (let i = 0; i < this.data.grnList.length; i++) {
      let cooly = this.grnData["no_of_bundle"] * 30;
      // let bundlepercooly = this.grnData['cooly_amt'] / cooly;
      if (isNaN(cooly)) {
        cooly = 0;
      }
      let totalrate = 0;
      totalrate = this.grnData.taxinvamount + this.grnData.lr_amount + cooly;
      this.data.grnList[i].lc_per =
        (totalrate / this.grnData.totalinvamt) * 100;
      this.data.grnList[i].lc_per = Math.round(
        this.data.grnList[i].lc_per
      ).toFixed(2);

      this.grnData["lc_per"] = this.data.grnList[i].lc_per;
    }

    return this.data.grnList;
  }

  onEnterInvRefNo() {
    let params = {
      inv_ref_no: this.grnData.inv_ref_no,
    };

    this.grn.getGrnInitData(params).then((res: any) => {
      if (!res.success) {
        return;
      }

      const inv = res.invData;
      this.tempData = inv;

      if (
        (inv.lr_stage == "LR Open" || inv.lr_stage == "LR Delivery") &&
        inv.invoice_type != "COURIER"
      ) {
        swal("LR NOT CLOSED..PLEASE ENTER `LR UPDATE` TO CLOSE LR");
        return;
      }
      if (inv.grn_id > 0) {
        swal("SAMPLE GRN INVOICE CANNOT BE PROCESSED");
        return;
      }

      this.grnData.party_code  = inv.party_code;
      this.grnData.party_name  = inv.party_name;
      this.grnData.party_id    = inv.party_id;
      this.grnData.po_no       = inv.po_no;
      this.grnData.po_id       = inv.po_id;
      this.grnData.invoice_no  = inv.invoice_no;
      this.grnData.lr_no       = inv.lr_no;
      this.grnData.inv_no      = inv.invoice_no;

      this.grnData["inv_date"]       = inv.invoice_date;
      this.grnData["inv_y_date"]     = inv.invoice_date;
      this.grnData["inv_amnt"]       = inv.grand_total;
      this.grnData["inv_id"]         = inv.inv_id;
      this.grnData["freight_charges"] = inv.freight_charge;
      this.grnData["no_of_bundle"]   = inv.no_of_bales;
      this.grnData["cooly_amt"]      = inv.cooly_amt;
      this.grnData["othersamt"]      = inv.others;
      this.grnData["taxinvamount"]   = inv.tax_amount;
      this.grnData["totalinvamt"]    = inv.totalamt;
      this.grnData["invoice_type"]   = inv.invoice_type;
      this.grnData["lr_amount"]      = inv.lr_amount;
      this.grnData["indent_no"]      = inv.indent_no;

      // All data arrives in one response — no sequential calls needed
      this.designList  = res.designList;
      this.invoiceList = res.invoiceList;

      // Update lrList with party-filtered records and resolve LR fields
      // skipDesignList=true: invoiceList already set above, no need for getDesignList call
      this.lrList = res.lrList;
      this.onClickLr(inv.lr_no, true);

      // Populate designnoList + po_id from PO data
      if (res.designnoList && res.designnoList.length > 0) {
        this.designnoList = res.designnoList;
        // Collect all unique po_ids across every PO on this invoice (may be multi-PO)
        const allPoIds = Array.from(new Set(res.designnoList.map((d: any) => String(d.po_id)))).join(',');
        this.grnData["po_id"]   = allPoIds;
        this.grnData["po_date"] = res.designnoList[0].po_date;
      }

      // Auto design number (previously came from lrlist())
      if (res.auto_design) {
        this.auto_number = res.auto_design;
      }
    });
  }

  onClickInv(invoice_no) {
    if (invoice_no != "") {
      let grpo = this.grnData.po_id;
      var grpo1 = new RegExp(grpo, "g");
      // let invDate = _.filter(this.lrList, { invoice_no: invoice_no });
      let invDate = [];
      this.lrList.forEach((element) => {
        let elpo = element.po_id;
        let elpo1 = elpo.toString();

        if (element.invoice_no == invoice_no) {
          invDate[0] = element;
        }
      });

      this.grnData["inv_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_y_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_amnt"] = invDate[0]["grand_total"];
      this.grnData["inv_id"] = invDate[0]["inv_id"];
      this.grnData["freight_charges"] = invDate[0]["freight_charge"];
      this.grnData["no_of_bundle"] = invDate[0]["no_of_bales"];
      this.grnData["cooly_amt"] = invDate[0]["cooly_amt"];
      this.grnData["othersamt"] = invDate[0]["others"];
      this.grnData["taxinvamount"] = invDate[0]["tax_amount"];
      this.grnData["totalinvamt"] = invDate[0]["totalamt"];
      this.grnData["invoice_type"] = invDate[0]["invoice_type"];
      this.grnData["lr_amount"] = invDate[0]["lr_amount"];
      //  this.grnData['inv_amnt'] = invDate[0]['inv_amnt'];
    } else {
      this.grnData["inv_y_date"] = "";
      this.grnData["inv_amnt"] = "";
    }
  }

  onClickPartyDesign(party_design, party_shade, ind, canShowSwal) {
    this.calcLCrate();
    // if the same pd_code is already loaded for this row, skip the popup
    if (this.loadedPdCodeMap[ind] === party_design) {
      canShowSwal = 'skip';
    } else {
      this.loadedPdCodeMap[ind] = party_design;
    }
    // if (party_shade != "") {
    this.data.grnList[ind].p_shade = party_shade;
    this.data.grnList[ind].des_no = party_design;

    let params = {
      party_design: party_design,
      shade: party_shade,
      party_id: this.grnData.party_id,
      po_id: this.grnData.po_id,
    };

    let that = this;

    this.tempcolorList = [];
    this.loadingRowInd = ind;
    Promise.all([
      that.grn.getsampleColor(params),
      that.grn.getPartyDesignDetails(params)
    ]).then(([colorRes, res]: any[]) => {
      that.loadingRowInd = -1;
      that.tempcolorList = colorRes.data;
      that.sample_check = colorRes.data.length > 0;

      if (res.success == true) {
        if (res.design_type == "PLAIN") {
          canShowSwal = "design";
          if (canShowSwal == "design") {
            that.checkCoreGangDesignDetails(res, party_design, party_shade, ind);
          }
        } else {
          let exists = this.designList.filter((el) => el.design_no == party_design);
          if (!exists && exists.length == 0) {
            this.data.grnList[ind].pd_code = "";
            $("#pd_code-" + ind).focus();
            swal("Design no doesn't exists in Invoice");
          } else {
            if (exists[0].design_type == "PLAIN") {
              if (canShowSwal == "design") {
                that.checkCoreGangDesignDetails(res, party_design, party_shade, ind);
              }
            } else {
              that.setDesignDetails(res, party_design, ind, canShowSwal);
            }
          }
        }
      } else {
        that.loadingRowInd = -1;
        setTimeout(() => { $("#shade-" + ind).focus(); }, 800);
        that.data.grnList[ind].color = "";
        swal("Design or Color doesn't exists in purchase order");
        return;
      }
      if (res.color) {
        if (res.color.length > 0) {
          that.colorList = res.color;
        }
      } else {
        that.colorList = that.colorListback;
      }
    });
    // }
  }

  checkCoreGangDesignDetails(res, party_design, party_shade, ind) {
    this.checkDesignShadeExistsInInvoice(party_design, party_shade, ind)
      .then((res1) => {
        if (res1) {
          this.setDesignDetails(res, party_design, ind, "color");
        }
        // else {
        //   this.data.grnList[ind].color = "";
        //   this.data.grnList[ind].design_no = "";
        //   swal("Shade doesn't exists in Invoice");
        // }
      })
      .catch((res1) => {
        return;
      });
  }
  openModalMismatch() {
  
  
    this.Is_Mismatch = true;
  }
  Modalhide(){
    this.Is_Mismatch = false;

  }
  setDesignDetails(res, party_design, ind, canShowSwal) {
    if (res.design_type == "PLAIN") {
      this.data.grnList[ind].design_type = res.data["design_type"];
      this.data.grnList[ind].rate = res.data["party_rate"];
      this.data.grnList[ind].design_no = res.data["core_designno"];
      // this.data.grnList[ind].shade = res.data["fabric_color"];
         this.data.grnList[ind].po_no = res.po_no; 
         this.data.grnList[ind].book_no = res.book_no; 
      this.data.grnList[ind].style = res.data["shirt_style"];
      this.data.grnList[ind].recvd_width = res.data["width"];
      this.data.grnList[ind].quality = res.data["quality"];
      this.data.grnList[ind].type = res.data["fabric_type"];
      this.data.grnList[ind].po_id = res.po_id;
      this.data.grnList[ind].shirt_style = res.data["shirt_style"];

      if (canShowSwal == "color") {
        swal("THIS IS A  " + this.data.grnList[ind].design_type + " DESIGN");
      }
    } else if (res.design_type == "CORE") {
      this.data.grnList[ind].design_type = res.data["design_type"];
      this.data.grnList[ind].rate = res.data["party_rate"];
      this.data.grnList[ind].design_no = res.data["core_designno"];
      // this.data.grnList[ind].shade = res.data["fabric_color"];
      this.data.grnList[ind].book_no = res.book_no;
      this.data.grnList[ind].po_no = res.po_no; 
      this.data.grnList[ind].style = res.data["shirt_style"];
      this.data.grnList[ind].recvd_width = res.data["width"];
      this.data.grnList[ind].quality = res.data["quality"];
      this.data.grnList[ind].type = res.data["fabric_type"];
      this.data.grnList[ind].po_id = res.po_id;
      this.data.grnList[ind].shirt_style = res.data["shirt_style"];

      if (canShowSwal == "color") {
        swal("THIS IS A  " + this.data.grnList[ind].design_type + " DESIGN");
      }
    } else {
      let newExists = res.data;

      this.data.grnList[ind].design_type = "NEW";
      this.data.grnList[ind].design_no = res.data["fabric_design"];
      this.data.grnList[ind].rate = res.data["rate"];
      this.data.grnList[ind].style = res.data["shirt_style"];
      this.data.grnList[ind].recvd_width = res.data["width"];
      this.data.grnList[ind].quality = res.data["quality"];
      this.data.grnList[ind].type = res.data["type"];
      this.data.grnList[ind].po_id = res.po_id;
      this.data.grnList[ind].po_no = res.data["po_no"]; 
      this.data.grnList[ind].book_no = res.data["book_no"]; 
      this.data.grnList[ind].shirt_style = res.data["shirt_style"];

      if (canShowSwal == "color" || canShowSwal == "design") {
        const colorWarning = this.tempcolorList.length === 0
          ? '<br/><br/><span style="color:#e67e22;font-weight:bold;">⚠ COLOR NOT IN LIST — No color history found for this design</span>'
          : '';
        swal({
          title: "LAST GENERATED DETAILS " + party_design + " - " + res.design_no,
          html: "PARTY CODE : " + newExists.party_code + "<br/>PO NO : " + newExists.po_no + "<br/>PO DATE : " + newExists.po_date + colorWarning,
          animation: false,
          allowEnterKey: true,
          focusConfirm: true,
          confirmButtonText: "OK",
          timer: 2000,
          onOpen: () => { const btn = document.querySelector('.swal2-confirm') as HTMLElement; if (btn) btn.focus(); },
        }).then(
          () => { setTimeout(() => { $("#shade-" + ind).focus(); }, 30); },
          () => { setTimeout(() => { $("#shade-" + ind).focus(); }, 30); }
        );
      }
    }
    if (this.mode === 'Add') {
      this.data.grnList[ind].actWidth = 0;
    }

  }
  addPaymentDet(data) {

     data.rate_diff = data.ord_price - data.rec_price;
     data.mtr_diff = data.inv_mtr - data.rec_mtr
   
    let rowdetail = Object.assign({}, data);
    this.partyDetails.push({ ...rowdetail });

  }
  OnselectShade(color, ind) {
    // Empty color is always allowed — user can leave it blank
    if (!color || color.trim() === '') {
      return;
    }

    // No colors loaded for this design — free entry, skip validation
    if (this.tempcolorList.length === 0) {
      $("#width-" + ind).focus();
      return;
    }

    const exist = this.tempcolorList.find(el => el.name == color);
    if (!exist) {
      this.data.grnList[ind].shade = '';
      swal({ title: "Color Not in List", text: "Please select a color from the list", type: "warning", animation: false, confirmButtonText: "OK" })
        .then(() => { setTimeout(() => { $("#shade-" + ind).focus(); }, 50); });
    } else {
      $("#width-" + ind).focus();
    }
  }
  checkDesignExistsInInvoice(party_design, ind, color, canShowSwal) {
    // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjjj");
    if (party_design != "") {
      let exists = this.designList.find((el) => el.design_no == party_design);
      if (!exists) {
        this.data.grnList[ind].pd_code = "";
        $("#pd_code-" + ind).focus();
        swal("Design no doesn't exists in Invoice");
      } else {
        let colorList = this.designList.map((el) => {
          if (el.design_no == party_design) {
            return el.shade;
          }
        });
        if (colorList.length > 0) {
          let shadeArr = "";
          colorList.forEach((el) => {
            if (el) {
              shadeArr += el + ",";
            }
          });


          this.designColorList = shadeArr
            .slice(0, -1)
            .split(",")
            .filter(function (color, index, self) {
              return self.indexOf(color) === index;
            });
        }
        this.onClickPartyDesign(party_design, color, ind, canShowSwal);
      }
    }
  }

  async checkDesignShadeExistsInInvoice(party_design, shade, ind) {
    // let exists: boolean = false;
    let exists: boolean = true;

    // await this.designList.forEach((el) => {
    //   if (el.design_no == party_design) {
    //     let shadeExplode = String(el.shade).split(",");
    //     shadeExplode.forEach((element) => {
    //       if (element == shade) {
    //         exists = true;
    //       }
    //     });
    //   }
    // });

    return exists;
  }

  // onclickpdcode(designshade, shade, ind, canShowSwal) {
  //   this.calcLCrate();
  //   this.data.grnList[ind].des_no = designshade;
  //   this.data.grnList[ind].p_shade = shade;

  //   let params = {
  //     pdesign_no: this.data.grnList[ind].des_no,
  //     shade: this.data.grnList[ind].p_shade,
  //     party_id: this.grnData.party_id,
  //   };
  //   this.grn.getCoreList(params).then((res: any) => {
  //     if (res.success == true) {
  //       this.data.grnList[ind].design_type = res.data[0]["type"];
  //       this.data.grnList[ind].design_no = res.data[0]["core_designno"];
  //       this.data.grnList[ind].shade = res.data[0]["fabric_color"];
  //       // this.data.grnList[ind].color = res.data[0]['shade'];
  //       this.data.grnList[ind].style = res.data[0]["fabric_style"];
  //       this.data.grnList[ind].isNew = false;
  //       if (canShowSwal == "color") {
  //         swal("THIS IS A  " + this.data.grnList[ind].design_type + " DESIGN");
  //       }
  //     } else {
  //       this.data.grnList[ind].design_type = "NEW";
  //       this.onClickDesign(this.data.grnList[ind].des_no, ind);
  //     }
  //     if (res.color.length > 0) {
  //       this.colorList = res.color;
  //     } else {
  //       this.colorList = this.colorListback;
  //     }
  //   });
  // }
  // onClickDesign(designno, ind) {
  //   //  let designData =  _.filter(this.designList, { design_no: designno });

  //   //   this.data.grnList[ind].des_no = designData[0]['design_no'];
  //   //      this.data.grnList[ind].design_shade = designData[0]['design_shade'];
  //   let des_no = this.data.grnList[ind].des_no;
  //   let design_shade = this.data.grnList[ind].color;
  //   for (let i = 0; i < this.data.grnList.length; i++) {
  //     if (i != ind && designno == this.data.grnList[i].des_no) {
  //       let design_no = this.data.grnList[i].design_no;
  //       this.data.grnList[ind].design_no = design_no;
  //       if (this.data.grnList[i].isNew == true) {
  //         this.data.grnList[ind].isNew = false;
  //       }

  //       return;
  //     }
  //   }
  //   this.generateOdNo(des_no, ind, design_shade);
  // }
  // generateOdNo(des_no, ind, design_shade) {
  //   let params = {
  //     design_shade: design_shade,
  //     des_no: des_no,
  //     party_id: this.grnData.party_id,
  //   };
  //   let that = this;
  //   that.grn.getAutoDesignNo(params).then((res: any) => {
  //     //  this.data.grnList[ind].design_no = res;
  //     that.data.grnList[ind].design_no = that.isSameDesignNo(
  //       des_no,
  //       res.design_no,
  //       ind,
  //       design_shade,
  //       res.newExists,
  //       res.coreExists,
  //       res.type
  //     );
  //   });
  // }
  // isSameDesignNo(party_des_no, res, ind, pd_code, newExists, coreExists, type) {
  //   //
  //   for (let i = 0; i < this.data.grnList.length - 1; i++) {
  //     if (
  //       ind != i &&
  //       res == this.data.grnList[i].design_no &&
  //       pd_code != this.data.grnList[i].des_no
  //     ) {
  //       res = res + 1;
  //       this.isSameDesignNo(
  //         party_des_no,
  //         res,
  //         ind,
  //         pd_code,
  //         newExists,
  //         coreExists,
  //         type
  //       );
  //     }
  //   }
  //   if (Object.entries(newExists).length > 0 && pd_code != "") {
  //     swal({
  //       title: "LAST GENERATED DETAILS " + party_des_no + " - " + res,
  //       html:
  //         "GRN NO : " +
  //         newExists.grn_no +
  //         "<br/>" +
  //         " GRN DATE : " +
  //         newExists.grn_date +
  //         "<br/>" +
  //         " INVOICE NO : " +
  //         newExists.invoice_no +
  //         "<br/>" +
  //         " INVOICE DATE : " +
  //         newExists.invoice_date,
  //     });
  //     this.data.grnList[ind].isNew = false;
  //   } else {
  //     this.data.grnList[ind].isNew = true;
  //   }
  //   return res;
  // }
  getDesign(po_no) {
    var regex = /^[A-Za-z0-9 ]+$/;
    var isValid = regex.test(po_no);
    if (isValid) {
      let params = {
        po_no: this.grnData.po_no,
        inv_ref_no: this.grnData.inv_ref_no,
      };
      this.grn.getDesign(params).then((res: any) => {
        this.designList = res.data;
        if (this.mode == "Edit") {
          this.partyCtrl.setValue(this.designdata["party_name"]);
        }
      });
    } else {
      let ponos = po_no.split(",");
      let ind = ponos.length;
      for (let i = 0; i < ponos.length; i++) {
        let params = {
          po_no: ponos[i],
          inv_ref_no: this.grnData.inv_ref_no,
        };
        this.grn.getDesign(params).then((res: any) => {
          this.designList = this.designList.concat(res.data);
          if (this.mode == "Edit") {
            this.partyCtrl.setValue(this.designdata["party_name"]);
          }
        });
      }
    }
  }
  getSamplePendingReturnDesigns(party_id) {
    let params = {
      party_id: party_id,
    };
    let that = this;
    that.grn.getSamplePendingReturnDesigns(params).then((res: any) => {
      that.samplePendingList = res.samplePendingList;
      that.returnDesignList = res.returnDesignList;
    });
  }
  onEnterpono(pono) {
    if (pono != "") {
      var regex = /^[A-Za-z0-9 ]+$/;
      var isValid = regex.test(pono);
      if (isValid) {
        let params = {
          po_no: pono,
        };
        let that = this;
        this.grn.getDesignno(params).then((res: any) => {
          if (res.data.length > 0) {
            that.designnoList = res.data;
            that.grnData["po_id"] = res.data[0].po_id;
            that.grnData["po_date"] = res.data[0]["po_date"];
            // that.grnData.party_code = res.data[0].party_code;
            // that.grnData.party_name = res.data[0].party_name;
            // that.grnData.party_id = res.data[0].party_id;
            // that.calcDiff();
            //that.grnData['diff_days'] = ((parseInt(that.grnData['grn_date']) - that.grnData['po_date']) / (1000 * 60 * 60 * 24));
            //  that.OnclickPartyCode(that.grnData.party_code);
          } else {
            (this.grnData.party_code = ""),
              (this.grnData["po_id"] = ""),
              (this.grnData.party_name = ""),
              (this.grnData["po_date"] = ""),
              (this.grnData["diff_days"] = "");
            if (this.mode != "View") {
              this.toasterService.pop({
                bodyOutputType: 1,
                type: "error",
                title: "Please Enter the valid Po.no",
              });
            }
          }
        });
      } else {
        let ponos = pono.split(",");
        let ind = ponos.length;
        let params = {
          po_no: ponos[ind - 1],
        };
        let that = this;
        this.grn.getDesignno(params).then((res: any) => {
          if (res.data.length > 0) {
            that.designnoList = that.designnoList.concat(res.data);
          }
        });
      }
    } else {
      (this.grnData.party_code = ""),
        (this.grnData["po_id"] = ""),
        (this.grnData.party_name = ""),
        (this.grnData["po_date"] = ""),
        (this.grnData["diff_days"] = "");
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "Please Enter the valid Po.no",
      });
    }
  }
  poMerge(pono) {
    let ponos = pono.split(",");
    let ind = ponos.length;
    let params = {
      po_no: ponos[ind - 1],
    };
    let that = this;
    this.grn.getDesignno(params).then((res: any) => {
      if (res.data.length > 0) {
        that.designnoList = that.designnoList.concat(res.data);
        this.grnData["po_id"] = this.grnData.po_id + "," + res.data[0].po_id;
      }
    });
  }
  calcDiff() {
    let date1 = new Date(this.grnData["lr_y_date"]);
    let date2 = new Date(this.grnData.grn_date);
    let diffDays = 0;
    this.grnData["diff_days"] = (date2.getTime() - date1.getTime()) / 86400000;
  }
  OnclickPartyCode(code) {
    let params = {
      code: code,
    };

    let that = this;
    this.grn.partyList(params).then((res: any) => {
      that.partyList = res.data;
      // that.grnData['party_name'] = res.data[0].party_name;
      // that.grnData['party_id'] = res.data[0].party_id;
    });
  }
  onchangeodno(od_no, ind) {
    let pdesign = this.data.grnList[ind].des_no;

    // for (let i = 0; i < this.data.grnList.length; i++) {
    //   if (pdesign == this.data.grnList[i].des_no) {
    //     this.data.grnList[i].design_no = od_no;
    //   }
    // }
  }
  generateDesignNo(ind) {
    if (this.data.grnList[ind].design_no == "") {
      this.data.grnList[ind].design_no = this.design_auto_no + ind;
    }
  }
  generateEditDesignNo(ind, fld) {
    let design_shade = this.data.grnList[ind].design_shade;
    if (fld == "designno") {
      if (this.mode == "Edit" && this.data.grnList[ind].design_no == "") {
        this.design_no += 1;
        this.data.grnList[ind].design_no = this.design_no;
      } else {
        this.generateDesignNo(ind);
      }
    }
  }
  calctot(ind) {
    let grn = this.data.grnList[ind];
    let rate = grn.rate;
    let lc_per = grn.lc_per;
    let qty = grn.qty;
    let amount = rate * qty;
    grn.lc_rate = (rate * lc_per) / 100;
    grn.amount = parseFloat(amount.toFixed(3));
    this.calcTotal();
    // this.calcRnd();
  }

  oncheckemptyrow() {
    let gnr = this.data.grnList;
    let grnList = [];
    // let state = false;

    for (let i = 0; i < gnr.length; i++) {
      if (gnr[i].pd_code != "" && gnr[i].actWidth > 0) {
        grnList.push(gnr[i]);
      } else {
        swal("ERROR", "Please Enter Actual Width!!", "error");
        return;
      }
    }

    if (this.mode == "Add") {
      this.getAuto();
    }
    if (this.mode == "Edit") {
      this.onSaveGrn();
    }

  }
  // this.data.grnList.forEach((el) => {
  //   let actWidth = el.actWidth;

  //   if (actWidth.length > 0) {
  //     this.data.grnList = grnList;

  //     if (this.mode == "Add") {
  //       this.getAuto();
  //     }
  //     if (this.mode == "Edit") {
  //       this.onSaveGrn();
  //     }
  //   }else{
  //     swal("ERROR"+"please enter a actual width");
  //   }
  // });

  calcTotal() {
    let grn = this.data.grnList;
    let totqty = 0,
      totalamt = 0;
    let disamt = 0;
    let roundoff = 0;
    let grantTotal = 0;
    let rnd = 0;
    let tax_per = this.grnData.tax_per;
    let taxamt = 0;
    let discount = this.grnData.discount;
    let tax = this.grnData.tax_per;
    let extras = this.grnData.extras;
    let otheramt = this.grnData.others;

    for (let i = 0; i < grn.length; i++) {
      let grndata = grn[i];
      totqty += parseFloat(grndata.qty);
      totalamt += grndata.amount;
    }
    taxamt = ((totalamt - discount + extras) * tax_per) / 100;
    if (isNaN(taxamt)) {
      taxamt = 0;
    }
    if (isNaN(discount)) {
      discount = 0;
    }
    if (isNaN(extras)) {
      extras = 0;
    }
    if (isNaN(otheramt)) {
      otheramt = 0;
    }

    grantTotal =
      Number(totalamt) -
      Number(discount) +
      Number(taxamt) +
      Number(extras) +
      Number(otheramt);

    this.grnData.totalqty = parseFloat(totqty.toFixed(2));
    this.grnData.tax_amount = parseFloat(taxamt.toFixed(2));
    this.grnData.totalamt = parseFloat(totalamt.toFixed(2));
    this.grnData.grand_total = grantTotal + this.grnData.round_off;
    this.grnData.grand_total = parseFloat(this.grnData.grand_total.toFixed(2));
    this.grnData.grandTotal = parseFloat(this.grnData.grand_total.toFixed(2));
    this.grnData.grand_total = this.moneyFormat(this.grnData.grand_total);
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
      return 0.0;
    let no = parseInt(nStr).toFixed(2);
    /*if (no < 0) {
            nStr = no * -1;
        }
        nStr += '';*/

    let x = no.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = x1.length;
    let num = len / 2 - 1;
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      } else {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      newval--;
      if (newval == 0) {
        break;
      }
    }

    let out = x1 + x2;
    // if (Number(no) < 0) {
    //     out = "(" + out + ")";
    // }
    return out;
  }
  canOpenInvoice() {
    let params = {
      inv_ref_no: this.grnData.inv_ref_no,
      grn_type: "GRN",
    };
    let that = this;
    that.grn
      .checkNonOrderExists(params)
      .then((res: any) => {
        if (res.success) {
          this.onEnterInvRefNo();
        } else {
          swal(
            "This Invoice " +
            res.grn_no +
            " has non-ordered designs.Please accept or return the goods and proceed"
          );
          return;
        }
      })
      .catch(() => { });
  }
  validateInvoice() {
    if (this.mode == "Edit" || this.mode == "View") {
      this.showbody();
    }
    if (this.mode == "Add") {
      let params = {
        inv_ref_no: this.grnData.inv_ref_no,
        inv_date: this.grnData.inv_date,
        party_code: this.grnData.party_code,
      };
      let that = this;
      that.grn
        .validateExists(params)
        .then((res: any) => {
          if (res.success) {

            that.showbody();
            // this.onEnterInvRefNo();
          } else {
            {
              swal("ERROR:SAME INVOICE NUMBER ALREADY EXIST", res.message, "error");
            }


          }
        })
        .catch(() => {

        });
    }
  }
  showHeader() {
    this.bodyShow = false;
    this.footerShow = false;
    this.samplePending = false;
    this.returnDesigns = false;
    this.headerShow = true;
  }
  showbody() {
    this.bodyShow = true;
    this.footerShow = true;
    this.samplePending = false;
    this.returnDesigns = false;
    this.headerShow = false;
    setTimeout(() => {
      $("#pdcode-0").focus();
    }, 500);
  }
  showSamplePending() {
    this.samplePending = true;
    this.bodyShow = false;
    this.returnDesigns = false;
    this.footerShow = false;
    this.headerShow = false;
    if (!this.samplePendingList || this.samplePendingList.length === 0) {
      this.getSamplePendingReturnDesigns(this.grnData.party_id);
    }
  }
  showReturnDetails() {
    this.returnDesigns = true;
    this.samplePending = false;
    this.bodyShow = false;
    this.footerShow = false;
    this.headerShow = false;
    if (!this.returnDesignList || this.returnDesignList.length === 0) {
      this.getSamplePendingReturnDesigns(this.grnData.party_id);
    }
  }

  onChange($event: Event, selected) {
    let el = $event;
    let checked = el["checked"];
    let grn_det_id = selected.grn_det_id;

    if (!checked) {
      this.selected = this.selected.filter((el) => el.grn_det_id != grn_det_id);
    } else {
      this.selected.push(selected);
    }
    this.data.grnList = this.data.grnList.filter(
      (el) => el.grn_det_id == undefined
    );
    this.data.grnList = this.data.grnList.concat(this.selected);

    if (this.data.grnList.length != 0) {
      this.data.grnList = this.data.grnList.filter((el) => el.pd_code != "");
    }
    this.calcTotal();
  }

  onChangeReturnDesigns($event: Event, selectedReturn) {
    let el = $event;
    let checked = el["checked"];
    let inv_det_id = selectedReturn.inv_det_id;

    if (!checked) {
      this.selectedReturn = this.selectedReturn.filter(
        (el) => el.inv_det_id != inv_det_id
      );
    } else {
      this.selectedReturn.push(selectedReturn);
    }
    this.data.grnList = this.data.grnList.filter(
      (el) => el.inv_det_id == undefined
    );
    this.data.grnList = this.data.grnList.concat(this.selectedReturn);
    if (this.data.grnList.length != 0) {
      this.data.grnList = this.data.grnList.filter((el) => el.pd_code != "");
    }
    this.calcTotal();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/grn/addEditGrn.ts